/**
 * @desc ponoStockDetail
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.StockOccupyMasterSelectRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/ponoStockDetail`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
